"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _InternalLink = _interopRequireDefault(require("./InternalLink"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint object-curly-newline: ["error", { "ObjectExpression": "always" }] */
// Component
const goBack = () => {
  window.history.back();
};

const GoBackLink = _ref => {
  let {
    children,
    onClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_InternalLink.default, {
    onClick: onClick || goBack,
    type: "small"
  }, children);
};

GoBackLink.propTypes = {
  children: _propTypes.default.string.isRequired,
  onClick: _propTypes.default.func
};
GoBackLink.defaultProps = {
  onClick: undefined
};
var _default = GoBackLink;
exports.default = _default;